import env from "@/common/env"
import { fabric } from "fabric"
import { cloneDeep } from "lodash-es"
import { isMobile } from "@/common/util/misc"
import { flagEnabled } from "@/signomatic/app/flags"

const moveCursor = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="#000" fill-rule="evenodd" d="M11.149 1.366a1.25 1.25 0 0 0-1.768 0l-2 2A1.25 1.25 0 0 0 9.015 5.25V9H5.25a1.25 1.25 0 0 0-1.884-1.634l-2 2a1.25 1.25 0 0 0 0 1.768l2 2A1.25 1.25 0 0 0 5.25 11.5h3.765v3.75a1.25 1.25 0 0 0-1.634 1.884l2 2a1.25 1.25 0 0 0 1.768 0l2-2a1.25 1.25 0 0 0-1.634-1.884V11.5h3.75a1.25 1.25 0 0 0 1.883 1.634l2-2a1.25 1.25 0 0 0 0-1.77l-2-1.998A1.25 1.25 0 0 0 15.266 9h-3.75V5.25a1.25 1.25 0 0 0 1.633-1.884l-2-2" clip-rule="evenodd"/><path fill="#fff" d="m9.38 1.366-.176-.177.177.177m1.768 0 .177-.177-.176.177M9.016 5.25h.25v-.5l-.4.3.15.2m0 3.75v.25h.25V9h-.25M5.25 9l-.2-.15-.3.4h.5V9m-3.884.366L1.19 9.19l.177.177m0 1.768-.177.177.177-.177m3.768 2 .177.177-.177-.177M5.25 11.5v-.25h-.5l.3.4.2-.15m3.765 0h.25v-.25h-.25v.25m0 3.75-.15.2.4.3v-.5h-.25m-1.634.116.177.177-.177-.177m0 1.768-.177.177.177-.177m2 2 .177-.177-.177.177m1.768 0-.177-.177.177.177m2-2 .176.177-.176-.177m-1.634-1.884h-.25v.5l.4-.3-.15-.2m0-3.75v-.25h-.25v.25h.25m3.75 0 .2.15.3-.4h-.5v.25m1.883 1.634-.176-.177.176.177m2-3.768-.176.177.176-.177m0-.001-.178.177.177-.177m-2-1.999.177-.177-.177.177m-1.767 0 .176.177-.176-.177M15.264 9v.25h.501l-.3-.4-.2.15m-3.75 0h-.25v.25h.25V9m0-3.75.15-.2-.4-.3v.5h.25m1.635-.116.176.177-.176-.177M9.558 1.543a1 1 0 0 1 1.414 0l.353-.354a1.5 1.5 0 0 0-2.121 0l.354.354Zm-2 2 2-2-.354-.354-2 2 .354.354m0 1.414a1 1 0 0 1 0-1.414l-.354-.354a1.5 1.5 0 0 0 0 2.122l.354-.354m1.306.093a1 1 0 0 1-1.306-.093l-.354.354a1.5 1.5 0 0 0 1.96.139l-.3-.4m.4 3.95V5.25h-.5V9h.5m-4.014.25h3.765v-.5H5.25v.5m-.293-1.707A1 1 0 0 1 5.05 8.85l.4.3a1.5 1.5 0 0 0-.14-1.96l-.353.353m-1.414 0a1 1 0 0 1 1.414 0l.354-.354a1.5 1.5 0 0 0-2.122 0l.354.354m-2 2 2-2-.354-.354-2 2 .354.354m0 1.414a1 1 0 0 1 0-1.414l-.354-.354a1.5 1.5 0 0 0 0 2.122l.354-.354m2 2-2-2-.354.354 2 2 .354-.354m1.414 0a1 1 0 0 1-1.414 0l-.354.354a1.5 1.5 0 0 0 2.122 0l-.354-.354m.093-1.307a1 1 0 0 1-.093 1.307l.354.354a1.5 1.5 0 0 0 .139-1.961l-.4.3m3.965-.4H5.25v.5h3.765v-.5m.25 4V11.5h-.5v3.75h.5m-1.707.293a1 1 0 0 1 1.306-.093l.3-.4a1.5 1.5 0 0 0-1.96.14l.354.353m0 1.414a1 1 0 0 1 0-1.414l-.354-.354a1.5 1.5 0 0 0 0 2.122l.354-.354m2 2-2-2-.354.354 2 2 .354-.354m1.414 0a1 1 0 0 1-1.414 0l-.354.354a1.5 1.5 0 0 0 2.121 0l-.353-.354m2-2-2 2 .353.354 2-2-.353-.354m0-1.414a1 1 0 0 1 0 1.414l.353.354a1.5 1.5 0 0 0 0-2.122l-.353.354m-1.307-.093a1 1 0 0 1 1.307.093l.353-.354a1.5 1.5 0 0 0-1.96-.139l.3.4m-.4-3.95v3.75h.5V11.5h-.5m4-.25h-3.75v.5h3.75v-.5m.292 1.707a1 1 0 0 1-.093-1.307l-.4-.3a1.5 1.5 0 0 0 .14 1.96l.353-.353m1.415 0a1 1 0 0 1-1.415 0l-.353.354a1.5 1.5 0 0 0 2.121 0l-.353-.354m2-2-2 2 .353.354 2-2-.353-.354m0-1.414a1 1 0 0 1 0 1.414l.353.354a1.5 1.5 0 0 0 0-2.122l-.353.354m-.001-.001.355-.352a.06.06 0 0 1-.002-.002l-.353.354m-2-2 2 2 .353-.354-1.999-1.999-.353.354m-1.414 0a1 1 0 0 1 1.415 0l.353-.353a1.5 1.5 0 0 0-2.121 0l.353.354m-.093 1.308a1 1 0 0 1 .093-1.307l-.353-.354a1.5 1.5 0 0 0-.14 1.961l.4-.3m-3.95.4h3.75v-.5h-3.75v.5m-.25-4V9h.5V5.25h-.5m1.708-.293a1 1 0 0 1-1.307.093l-.3.4a1.5 1.5 0 0 0 1.96-.14l-.353-.353m0-1.414a1 1 0 0 1 0 1.414l.353.354a1.5 1.5 0 0 0 0-2.122l-.353.354m-2-2 2 2 .353-.354-2-2-.353.354"/></svg>
`

export const getRotateCursor = (angle: number) => {
  const normalizedAngle = angle % 360

  const rotateCursor = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g transform="rotate(${normalizedAngle}, 12, 12)"> <!-- Rotate around the center -->
        <mask id="a" width="20" height="8" x="2" y="8" maskUnits="userSpaceOnUse" style="mask-type:luminance">
          <path fill="#fff" d="M22 8H2v8h20z"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#000" fill-rule="evenodd" d="M5.25 13a1.25 1.25 0 1 1-2.5 0v-3A1.25 1.25 0 0 1 4 8.75h3a1.25 1.25 0 0 1 .12 2.494l.182.122c.5.332 1.04.597 1.61.787l.637.212c1.591.53 3.311.53 4.902 0l.764-.254a5.75 5.75 0 0 0 1.372-.671l.293-.196A1.25 1.25 0 0 1 17 8.75h3A1.25 1.25 0 0 1 21.25 10v3a1.25 1.25 0 1 1-2.5 0 1.279 1.279 0 0 1-.056.04l-.72.48a8.24 8.24 0 0 1-1.968.962l-.765.255a10.25 10.25 0 0 1-6.482 0l-.638-.212a9.249 9.249 0 0 1-2.206-1.08l-.608-.405A1.25 1.25 0 0 1 5.25 13" clip-rule="evenodd"/>
        </g>
      </g>
    </svg>
  `
  const rotateCursorEncoded = encodeURIComponent(rotateCursor.trim())
  return `url("data:image/svg+xml;charset=utf-8,${rotateCursorEncoded}") 12 12, alias`
}

const moveCursorEncoded = encodeURIComponent(moveCursor)

const getControlImagePaths = (): StringMap<string> => {
  return {
    rotate: flagEnabled("clarify-object-controls")
      ? "/images/signomatic/bounding_box/rotate-object-3.svg"
      : "/images/signomatic/bounding_box/rotate-object-2.svg",
    move: flagEnabled("clarify-object-controls")
      ? "/images/signomatic/bounding_box/move-2.svg"
      : "/images/signomatic/bounding_box/move.svg",
  }
}

const controlImageMap: StringMap<string> = {
  mtr: "rotate",
  move: "move",
}

const controlImages: ImageMap = {}

export const loadControlImages = () => {
  if (env.isJSDOM) {
    return
  }

  const controlImagePaths = getControlImagePaths()

  for (const key in controlImagePaths) {
    if (Object.prototype.hasOwnProperty.call(controlImagePaths, key)) {
      const path = controlImagePaths[key]

      fabric.util.loadImage(path, img => {
        controlImages[key] = img
      })
    }
  }
}

const getControlImage = (control: string): HTMLImageElement | null => {
  const key = controlImageMap[control]

  if (key) {
    return controlImages[key]
  }

  return null
}

const controlsThreshold = (objectType: string, canvasZoom: number) => {
  if (!canvasZoom) {
    return 1
  }

  if (isMobile()) {
    if (objectType === "i-text") {
      if (canvasZoom > 1.9) return 17
      if (canvasZoom > 0.71) return 33
      if (canvasZoom > 0.38) return 55
      if (canvasZoom > 0.25) return 110
      if (canvasZoom > 0.175) return 145
      if (canvasZoom > 0.165) return 150
      if (canvasZoom > 0.16) return 200
      if (canvasZoom > 0.12) return 280
      if (canvasZoom > 0.08) return 355
      if (canvasZoom > 0.06) return 480
      return 920
    } else {
      if (canvasZoom > 1.9) return 60
      if (canvasZoom > 0.6) return 160
      if (canvasZoom > 0.25) return 180
      if (canvasZoom > 0.175) return 200
      if (canvasZoom > 0.165) return 210
      if (canvasZoom > 0.15) return 220
      if (canvasZoom > 0.1) return 230
      return 240
    }
  } else {
    if (objectType === "i-text") {
      if (canvasZoom > 3) return 6
      if (canvasZoom > 1.9) return 10
      if (canvasZoom > 0.71) return 20
      if (canvasZoom > 0.6) return 30
      if (canvasZoom > 0.38) return 50
      if (canvasZoom > 0.25) return 70
      if (canvasZoom > 0.175) return 110
      if (canvasZoom > 0.165) return 130
      if (canvasZoom > 0.16) return 140
      return 150
    } else {
      if (canvasZoom > 1.9) return 90
      if (canvasZoom > 0.6) return 92
      if (canvasZoom > 0.25) return 95
      if (canvasZoom > 0.175) return 100
      if (canvasZoom > 0.165) return 105
      if (canvasZoom > 0.145) return 110
      return 150
    }
  }
}

const controlImageMlThreshold = () => {
  return isMobile() ? 100 : 70
}

const hideControls = (objectWidth: number, objectHeight: number, threshold: number) => {
  return objectWidth < threshold || objectHeight < threshold
}

const controls = cloneDeep(new fabric.Text("").controls)

// https://github.com/fabricjs/fabric.js/blob/v460/src/controls.render.js#L20
const circleRender = function (
  this: fabric.Control,
  ctx: CanvasRenderingContext2D,
  left: number,
  top: number,
  styleOverride: any,
  fabricObject: fabric.Object
) {
  // Set controls attributes inside a function in order to get the correct flag value
  controls["mtr"].withConnection = false
  controls["mtr"].y = 0.5
  controls["mtr"].offsetY = flagEnabled("clarify-object-controls") ? (isMobile() ? 54 : 36) : 60
  controls["mtr"].cursorStyle = "pointer"

  if (flagEnabled("clarify-object-controls")) {
    controls["mtr"].offsetX = 0
    controls["mtr"].cursorStyle = getRotateCursor(fabricObject.angle || 0)
  }

  controls["mtr"].calcCornerCoords = flagEnabled("clarify-object-controls") ? calcCornerCoordsV2 : calcCornerCoords
  controls["mtr"].render = function (this: fabric.Control, ctx, left, top, styleOverride, fabricObject) {
    const hideControl = hideControls(
      fabricObject.width || 1,
      fabricObject.height || 1,
      controlsThreshold(fabricObject.type || "", fabricObject.canvas?.getZoom() || 1)
    )
    const offsetX = flagEnabled("clarify-object-controls") ? (hideControl ? 46 : 20) : hideControl ? -26 : 0
    const img = getControlImage("mtr")

    ctx.save()

    if (flagEnabled("clarify-object-controls")) {
      const lowestY = fabricObject.oCoords
        ? Math.max(
            fabricObject.oCoords.bl.y,
            fabricObject.oCoords.br.y,
            fabricObject.oCoords.tl.y,
            fabricObject.oCoords.tr.y
          )
        : 0

      const objectCenter = fabricObject.getCenterPoint()
      const canvas = fabricObject.canvas
      const viewportTransform = canvas?.viewportTransform || [1, 0, 0, 1, 0, 0]

      const screenCenter = fabric.util.transformPoint(objectCenter, viewportTransform)

      top = Math.min(lowestY + (isMobile() ? 26 : 18), ((fabricObject.canvas && fabricObject.canvas.height) || 0) - 44)
      left = screenCenter.x
    } else {
      ctx.translate(left, top)
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle || 0))
      ctx.translate(-left, -top)
    }

    if (!flagEnabled("clarify-object-controls")) {
      drawBgCircle(left + offsetX, top, ctx)
    }

    if (img) {
      if (flagEnabled("clarify-object-controls")) {
        ctx.drawImage(img, left - offsetX, top, 40, 40)
      } else {
        ctx.drawImage(img, left + offsetX - 14, top - 14, 26, 26)
      }
    } else {
      circleRender.bind(this)(ctx, left + offsetX, top, styleOverride, fabricObject)
    }

    ctx.restore()
  }

  controls["move"] = new fabric.Control({
    y: 0.5,
    offsetY: flagEnabled("clarify-object-controls") ? (isMobile() ? 54 : 36) : 60,
    offsetX: flagEnabled("clarify-object-controls") ? 24 : 26,
    cursorStyle: flagEnabled("clarify-object-controls")
      ? `url("data:image/svg+xml;charset=utf-8,${moveCursorEncoded}") 12 12, move`
      : "pointer",
    render: renderMoveControl,
    calcCornerCoords: flagEnabled("clarify-object-controls") ? calcCornerCoordsV2 : calcCornerCoords,
    actionHandler: (fabric as any).controlsUtils.dragHandler,
    actionName: "drag",
    mouseDownHandler: (eventData, transform) => {
      if (flagEnabled("clarify-object-controls")) {
        transform.target.canvas?.setCursor(`url("data:image/svg+xml;charset=utf-8,${moveCursorEncoded}") 12 12, move`)
      }

      return true
    },
    mouseUpHandler: (eventData, transform) => {
      if (flagEnabled("clarify-object-controls")) {
        transform.target.canvas?.setCursor(`url("data:image/svg+xml;charset=utf-8,${moveCursorEncoded}") 12 12, move`)
      }

      return true
    },
  })

  const showMl = !hideControls(fabricObject.width || 1, fabricObject.height || 1, controlImageMlThreshold())

  if (
    hideControls(
      fabricObject.width || 1,
      fabricObject.height || 1,
      controlsThreshold(fabricObject.type || "", fabricObject.canvas?.getZoom() || 1)
    )
  ) {
    if (fabricObject.type === "i-text") {
      fabricObject.setControlsVisibility({ bl: false, tl: false, tr: false })
    } else {
      fabricObject.setControlsVisibility({
        bl: false,
        tl: false,
        tr: false,
        mt: false,
        mr: false,
        mb: false,
        ml: showMl,
      })
    }
  } else {
    if (fabricObject.type === "i-text") {
      fabricObject.setControlsVisibility({ bl: true, tl: true, tr: true })
    } else {
      fabricObject.setControlsVisibility({
        bl: true,
        tl: true,
        tr: true,
        mt: true,
        mr: true,
        mb: true,
        ml: true,
      })
    }
  }
  styleOverride = styleOverride || {}
  const xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize
  const ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize
  const transparentCorners =
    typeof styleOverride.transparentCorners !== "undefined"
      ? styleOverride.transparentCorners
      : fabricObject.transparentCorners
  const methodName = transparentCorners ? "stroke" : "fill"
  const stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor)
  let myLeft = left
  let myTop = top
  let size

  ctx.save()
  ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor
  ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor

  if (xSize > ySize) {
    size = xSize
    ctx.scale(1.0, ySize / xSize)
    myTop = (top * xSize) / ySize
  } else if (ySize > xSize) {
    size = ySize
    ctx.scale(xSize / ySize, 1.0)
    myLeft = (left * ySize) / xSize
  } else {
    size = xSize
  }
  // custom border width
  ctx.lineWidth = 2
  ctx.beginPath()
  ctx.arc(myLeft, myTop, size / 2, 0, 2 * Math.PI, false)
  ctx[methodName]()
  if (stroke) {
    ctx.stroke()
  }
  ctx.restore()
}

const drawBgCircle = function (left: number, top: number, ctx: CanvasRenderingContext2D) {
  ctx.beginPath()
  ctx.arc(left - 1, top - 1, 19, 0, Math.PI * 2)
  ctx.fillStyle = "#FFFFFF"
  ctx.fill()
  ctx.strokeStyle = "#E0E6EA"
  ctx.lineWidth = 1
  ctx.stroke()
}

const renderMoveControl = function (
  this: fabric.Control,
  ctx: CanvasRenderingContext2D,
  left: number,
  top: number,
  styleOverride: any,
  fabricObject: fabric.Object
) {
  if (
    !hideControls(
      fabricObject.width || 1,
      fabricObject.height || 1,
      controlsThreshold(fabricObject.type || "", fabricObject.canvas?.getZoom() || 1)
    )
  ) {
    return
  }

  const img = getControlImage("move")

  ctx.save()

  if (flagEnabled("clarify-object-controls")) {
    const lowestY = fabricObject.oCoords
      ? Math.max(
          fabricObject.oCoords.bl.y,
          fabricObject.oCoords.br.y,
          fabricObject.oCoords.tl.y,
          fabricObject.oCoords.tr.y
        )
      : 0

    const objectCenter = fabricObject.getCenterPoint()
    const canvas = fabricObject.canvas
    const viewportTransform = canvas?.viewportTransform || [1, 0, 0, 1, 0, 0]

    const screenCenter = fabric.util.transformPoint(objectCenter, viewportTransform)

    top = Math.min(lowestY + (isMobile() ? 26 : 18), ((fabricObject.canvas && fabricObject.canvas.height) || 0) - 44)
    left = screenCenter.x + 6
  }

  if (!flagEnabled("clarify-object-controls")) {
    drawBgCircle(left, top, ctx)
  }

  if (img) {
    if (flagEnabled("clarify-object-controls")) {
      ctx.drawImage(img, left, top, 40, 40)
    } else {
      ctx.drawImage(img, left - 14, top - 14, 26, 26)
    }
  } else {
    ctx.beginPath()
    ctx.arc(0, 0, 10, 0, Math.PI * 2)
    ctx.fill()
  }

  ctx.restore()
}

// https://github.com/fabricjs/fabric.js/blob/v5.3.1/src/control.class.js#L264
const calcCornerCoords = function (
  objectAngle: number,
  objectCornerSize: number,
  centerX: number,
  centerY: number,
  isTouch: boolean,
  fabricObject?: fabric.Object
) {
  const hideControl = hideControls(
    fabricObject?.width || 1,
    fabricObject?.height || 1,
    controlsThreshold(fabricObject?.type || "", fabricObject?.canvas?.getZoom() || 1)
  )

  if (!hideControl && this.actionName === "drag") {
    return {
      tl: { x: 0, y: 0 },
      tr: { x: 0, y: 0 },
      bl: { x: 0, y: 0 },
      br: { x: 0, y: 0 },
    }
  }

  const angleToRadians = fabric.util.degreesToRadians(objectAngle)
  let cosHalfOffset, sinHalfOffset, cosHalfOffsetComp, sinHalfOffsetComp
  const xSize = isTouch ? this.touchSizeX : this.sizeX
  const ySize = isTouch ? this.touchSizeY : this.sizeY

  if (xSize && ySize && xSize !== ySize) {
    const controlTriangleAngle = Math.atan2(ySize, xSize)
    const cornerHypotenuse = Math.sqrt(xSize * xSize + ySize * ySize) / 2
    const newTheta = controlTriangleAngle - angleToRadians
    const newThetaComp = Math.PI / 2 - controlTriangleAngle - angleToRadians
    cosHalfOffset = cornerHypotenuse * (fabric as any).util.cos(newTheta)
    sinHalfOffset = cornerHypotenuse * (fabric as any).util.sin(newTheta)
    cosHalfOffsetComp = cornerHypotenuse * (fabric as any).util.cos(newThetaComp)
    sinHalfOffsetComp = cornerHypotenuse * (fabric as any).util.sin(newThetaComp)
  } else {
    const cornerSize = xSize && ySize ? xSize : flagEnabled("clarify-object-controls") ? 40 : 30
    const cornerHypotenuse = cornerSize * 0.7071067812
    const newTheta = fabric.util.degreesToRadians(45 - objectAngle)
    cosHalfOffset = cosHalfOffsetComp = cornerHypotenuse * (fabric as any).util.cos(newTheta)
    sinHalfOffset = sinHalfOffsetComp = cornerHypotenuse * (fabric as any).util.sin(newTheta)
  }

  const angleOffset = {
    x: (fabric as any).util.cos(angleToRadians) * -26,
    y: (fabric as any).util.sin(angleToRadians) * -26,
  }

  const offset = hideControl && this.actionName === "rotate" ? angleOffset : { x: 0, y: 0 }
  const adjustedCenterX = centerX + offset.x
  const adjustedCenterY = centerY + offset.y

  return {
    tl: {
      x: adjustedCenterX - sinHalfOffsetComp,
      y: adjustedCenterY - cosHalfOffsetComp,
    },
    tr: {
      x: adjustedCenterX + cosHalfOffset,
      y: adjustedCenterY - sinHalfOffset,
    },
    bl: {
      x: adjustedCenterX - cosHalfOffset,
      y: adjustedCenterY + sinHalfOffset,
    },
    br: {
      x: adjustedCenterX + sinHalfOffsetComp,
      y: adjustedCenterY + cosHalfOffsetComp,
    },
  }
}

const calcCornerCoordsV2 = function (
  objectAngle: number,
  objectCornerSize: number,
  centerX: number,
  centerY: number,
  isTouch: boolean,
  fabricObject?: fabric.Object
) {
  if (!fabricObject) {
    return
  }

  const hideControl = hideControls(
    fabricObject.width || 1,
    fabricObject.height || 1,
    controlsThreshold(fabricObject.type || "", fabricObject.canvas?.getZoom() || 1)
  )

  if (!hideControl && this.actionName === "drag") {
    return {
      tl: { x: 0, y: 0 },
      tr: { x: 0, y: 0 },
      bl: { x: 0, y: 0 },
      br: { x: 0, y: 0 },
    }
  }

  const xSize = isTouch ? this.touchSizeX : this.sizeX
  const ySize = isTouch ? this.touchSizeY : this.sizeY
  const cornerSize = xSize && ySize ? xSize : 40

  const offsetY = isMobile() ? 26 : 18
  const lowestY = fabricObject.oCoords
    ? Math.max(
        fabricObject.oCoords.bl.y,
        fabricObject.oCoords.br.y,
        fabricObject.oCoords.tl.y,
        fabricObject.oCoords.tr.y
      )
    : 0

  const objectCenter = fabricObject.getCenterPoint()
  const canvas = fabricObject.canvas
  const viewportTransform = canvas?.viewportTransform || [1, 0, 0, 1, 0, 0]

  const screenCenter = fabric.util.transformPoint(objectCenter, viewportTransform)

  if (this.actionName === "rotate") {
    centerY = Math.min(lowestY + offsetY + 20, (canvas?.height || 0) - 22)
    centerX = screenCenter.x - (hideControl ? 26 : 0)
  }

  if (this.actionName === "drag") {
    centerY = Math.min(lowestY + offsetY + 20, (canvas?.height || 0) - 22)
    centerX = screenCenter.x + (hideControl ? 26 : 0)
  }

  const halfWidth = (xSize || cornerSize) / 2
  const halfHeight = (ySize || cornerSize) / 2

  return {
    tl: {
      x: centerX - halfWidth,
      y: centerY - halfHeight,
    },
    tr: {
      x: centerX + halfWidth,
      y: centerY - halfHeight,
    },
    bl: {
      x: centerX - halfWidth,
      y: centerY + halfHeight,
    },
    br: {
      x: centerX + halfWidth,
      y: centerY + halfHeight,
    },
  }
}

controls["tl"].render = circleRender
controls["tr"].render = circleRender
controls["bl"].render = circleRender
controls["br"].render = circleRender
controls["ml"].render = circleRender
controls["mr"].render = circleRender
controls["mt"].render = circleRender
controls["mb"].render = circleRender

const calcCornerCoordsFunc = flagEnabled("clarify-object-controls") ? calcCornerCoordsV2 : calcCornerCoords
controls["tl"].calcCornerCoords = calcCornerCoordsFunc
controls["tr"].calcCornerCoords = calcCornerCoordsFunc
controls["bl"].calcCornerCoords = calcCornerCoordsFunc
controls["br"].calcCornerCoords = calcCornerCoordsFunc
controls["ml"].calcCornerCoords = calcCornerCoordsFunc
controls["mr"].calcCornerCoords = calcCornerCoordsFunc
controls["mt"].calcCornerCoords = calcCornerCoordsFunc
controls["mb"].calcCornerCoords = calcCornerCoordsFunc

export default controls
